import { render, staticRenderFns } from "./AskCost.vue?vue&type=template&id=c5b3dd34"
import script from "./AskCost.vue?vue&type=script&lang=js"
export * from "./AskCost.vue?vue&type=script&lang=js"
import style0 from "./AskCost.vue?vue&type=style&index=0&id=c5b3dd34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports